import styled from "styled-components";
import githubImage from "images/optimized/oss/github.webp";
import siImage from "images/optimized/oss/si.webp";
import ssgImage from "images/optimized/oss/ssg.webp";
import { BsArrowUpRight } from "react-icons/bs";
import { Image } from "components/image";

const projects = [
  {
    name: "SignalRSwaggerGen",
    description: "Generate clear Swagger documentation for SignalR hubs.",
    href: "https://www.nuget.org/packages/SignalRSwaggerGen",
    image: ssgImage,
  },
  {
    name: "SerializationInterceptor",
    description: "Intercept attribute parameter values during serialization and deserialization.",
    href: "https://www.nuget.org/packages/SerializationInterceptor",
    image: siImage,
  },
];

const StyledOss = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledHeader = styled.h2`
  font-family: Roboto-Black;
  color: #f0ece5;
  text-align: center;
  text-transform: uppercase;
`;

const StyledIntro = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  max-width: 620px;
  margin-bottom: 38px;
  color: #b8c1c7;
  font-family: Roboto-Light;
  font-size: 18px;
  line-height: 1.6;
  text-align: center;
`;

const StyledGitHubLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, .06);
  color: #f0ece5;
  font-family: Roboto-Regular;
  font-size: 13px;
  letter-spacing: .08em;
  text-transform: uppercase;

  &:hover { background: rgba(57, 137, 166, .18); }
`;

const StyledGitHubImage = styled(Image)`
  width: 24px;
  height: 24px;
`;

const StyledProjects = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;

const StyledProject = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: clamp(24px, 4vw, 38px);
  border: 1px solid rgba(220, 226, 230, .1);
  border-radius: 22px;
  background: rgba(5, 12, 20, .22);
  text-align: center;
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(57, 137, 166, .45);
    background: rgba(57, 137, 166, .08);
  }
`;

const StyledProjectImage = styled(Image)`
  width: 76px;
  height: 76px;
  border-radius: 18px;
`;

const StyledProjectTitle = styled.strong`
  color: #f0ece5;
  font-family: Roboto-Black;
  font-size: clamp(18px, 2vw, 23px);
`;

const StyledProjectDescription = styled.span`
  max-width: 430px;
  color: #b8c1c7;
  font-family: Roboto-Light;
  font-size: 16px;
  line-height: 1.55;
`;

const StyledProjectArrow = styled(BsArrowUpRight)`
  position: absolute;
  top: 20px;
  right: 22px;
  width: 30px;
  height: 30px;
  color: #3989a6 !important;
  transition: transform 180ms ease;

  ${StyledProject}:hover & {
    transform: translate(2px, -2px);
  }

  @media (max-width: 420px) {
    top: 16px;
    right: 17px;
    width: 25px;
    height: 25px;
  }
`;

export const Oss = () => (
  <StyledOss id="oss">
    <StyledHeader>We contribute to open source</StyledHeader>
    <StyledIntro>
      <span>Reusable tools from our day-to-day engineering work, shared with the community.</span>
      <StyledGitHubLink href="https://github.com/essencebit" target="_blank" rel="noreferrer">
        <StyledGitHubImage src={githubImage} alt="" /> View our GitHub
      </StyledGitHubLink>
    </StyledIntro>
    <StyledProjects>
      {projects.map((project) => (
        <StyledProject key={project.name} href={project.href} target="_blank" rel="noreferrer">
          <StyledProjectImage src={project.image} alt="" />
          <StyledProjectTitle>{project.name}</StyledProjectTitle>
          <StyledProjectDescription>{project.description}</StyledProjectDescription>
          <StyledProjectArrow aria-hidden="true" focusable="false" />
        </StyledProject>
      ))}
    </StyledProjects>
  </StyledOss>
);
